import * as pym from 'pym.js'

class Pym {
    pymChild = new pym.Child();
}

export default Pym;
